import socketMiddleware from '../middlewares/socket';
import xmppMiddleware from '../middlewares/xmpp';
import mapMiddleware from '../middlewares/map';
import analyzeMiddleware from '../middlewares/analyze';
import dashboardMiddleware from '../middlewares/dashboard';
import farmMonitorMiddleware from '../middlewares/farm-monitor';
import scaleSocketMiddleware from '../middlewares/scale-socket';

export { socketMiddleware, mapMiddleware, analyzeMiddleware, dashboardMiddleware, farmMonitorMiddleware, xmppMiddleware, scaleSocketMiddleware };